import React, { useState} from "react";
import logo from "../icons/LoginLogo.svg";
import ForgetCodeModal from "../components/loginPage/ForgetCodeModal";
// import { useSendUserDataMutation } from "../service/loginApi";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import agroyaarLogo2 from "../icons/agroyaar logo 2.svg";

import LoginForm from "../features/Login/Form";

function LoginPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // const [sendUserData] = useSendUserDataMutation();

  


  return (
    <>
      <ToastContainer position="top-right" rtl={true} newestOnTop={true} />
      <div className=" absolute item-center   h-full w-full bg-[#e7edf3] overflow-hidden">
        {isModalOpen && (
          <ForgetCodeModal onClose={() => setIsModalOpen(false)} />
        )}
        <div className=" relative h-screen w-screen top-[7vh] max-lg:top-6  justify-center  ">
          <div
            id="loginPage"
            className="  flex flex-row justify-center mx-auto gap-20  items-center max-lg:h-[87%] w-[85%] max-lg:w-full  p-8 max-lg:p-0  bg-gradient-to-r from-[#92B2E3] to-[#D3E6FDA6] rounded-[20px]"
          >
            <div className="flex flex-col items-center gap-3 max-lg:gap-3 max-lg:h-[85%] max-lg:w-[95%]">
              
              <img
                src={agroyaarLogo2}
                alt="agroyar"
                className="hidden max-lg:block max-lg:w-[60%] max-lg:pb-6  "
              />
              <LoginForm />
            </div>

            <div className=" max-xl:hidden flex flex-col justify-center  ">
              <img alt="logo" src={agroyaarLogo2}/>
              <img alt="background" src={logo} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
